import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ButtonSplitGroup, ExportToCSVButton } from '@components/Buttons';
import { renderInfinityChannels } from '@components/Product/Pricelists/functions';
import { BootstrapGenericTable } from '@components/Table/Table';

export const DedicatedChannelsTable = ({ useData, searchParams }) => {
  const country = searchParams.get('country');
  const plan = searchParams.get('plan');
  const did = searchParams.get('did');
  const filterData = {
    country,
    plan,
    did,
  };

  const exportContent = () => (
    <ButtonSplitGroup>
      <Button
        as={Link}
        variant="didxl"
        size="sm"
        to={`/order/dedicated-channels?${searchParams.toString()}`}
      >
        Buy channels
      </Button>
      <Button
        as={Link}
        variant="didxl"
        size="sm"
        to="/order/dedicated-channels/cancel"
      >
        Cancel channels
      </Button>
      <ExportToCSVButton
        to="customer/dids/dedicated-channels/existing/export"
        filterData={{ ...filterData, csv_export: true }}
      />
    </ButtonSplitGroup>
  );

  const columns = useMemo(
    () => [
      {
        id: 'did',
        Header: 'Number',
        accessor: 'did',
        className: 'col-md-1',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country',
        className: 'col-md-2',
      },
      {
        id: 'profileName',
        Header: 'End user',
        accessor: 'account',
        className: 'col-md-2',
      },
      {
        id: 'plan',
        Header: 'Plan',
        accessor: 'plan',
        className: 'col-md-1 text-center',
      },
      {
        Header: '# Ded. Chan',
        accessor: 'n_channels',
        className: 'col-md-1 text-center',
      },
      {
        Header: 'Max Ded. Chan',
        accessor: 'max_n_channels',
        className: 'col-md-1 text-center',
        Cell: renderInfinityChannels,
      },
    ],
    [country, plan, did]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        Numbers with dedicated channels
      </Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          exportContent={exportContent}
        />
      </Card.Body>
    </Card>
  );
};
